import { render, staticRenderFns } from "./password.vue?vue&type=template&id=7e22890c&"
import script from "./password.vue?vue&type=script&lang=js&"
export * from "./password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e22890c')) {
      api.createRecord('7e22890c', component.options)
    } else {
      api.reload('7e22890c', component.options)
    }
    module.hot.accept("./password.vue?vue&type=template&id=7e22890c&", function () {
      api.rerender('7e22890c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/form-templates/password.vue"
export default component.exports